import { checkXWithRoomSize, checkYWithRoomSize } from './HelpLinesUtils';
// Specification: Squared shape right corner
//
// 1--------2\
// |        | \
// |        |  \
// |        |   3
// 0--------5   |
//           \  |
//            \ |
//             \|
//              4
export class SquaredShapeRightCorner {
    /**
     *
     */
    constructor(rightWallPos) {
        this.rightWallPos = rightWallPos;
    }
    getShape() {
        return [
            { point: { x: this.rightWallPos - 2, y: 0, z: 0 } }, // 0
            { point: { x: this.rightWallPos - 2, y: 2.4, z: 0 } }, // 1
            {
                point: { x: this.rightWallPos, y: 2.4, z: 0 },
                noHandle: true,
                rotation: -90
            }, // 2
            { point: { x: this.rightWallPos, y: 2.4, z: 2 }, rotation: -90 }, // 3
            { point: { x: this.rightWallPos, y: 0, z: 2 }, rotation: -90 }, // 4
            { point: { x: this.rightWallPos, y: 0, z: 0 }, noHandle: true, rotation: -90 } // 5
        ];
    }
    moveHandle(corners, handle, delta, roomDimensions) {
        const { handle: { position: { x, y, z } } } = handle;
        const { minHeight, minWidth, minDepth } = { minHeight: 2.1, minWidth: 1, minDepth: 1 };
        let newX = x + delta.x;
        let newY = y + delta.y;
        const newZ = Math.min(Math.max(minDepth, z + delta.z), roomDimensions.maxY);
        newY = Math.max(minHeight, newY);
        const closestToSibblingHandle = 0.05;
        switch (handle) {
            case corners[0]:
                newX = Math.min(corners[2].getPosition().x - closestToSibblingHandle, corners[3].getPosition().x - minWidth, newX);
                newX = checkXWithRoomSize(roomDimensions, newX);
                corners[0].moveTo(newX, corners[0].getPosition().y, 0);
                corners[1].moveTo(newX, corners[1].getPosition().y, 0);
                break;
            case corners[1]:
                {
                    newX = Math.min(corners[2].getPosition().x - closestToSibblingHandle, corners[3].getPosition().x - minWidth, newX);
                    const minY = corners[1].getPosition().y < minHeight ? minHeight : closestToSibblingHandle;
                    if (newY <= minY) {
                        newY = minY;
                    }
                    newX = checkXWithRoomSize(roomDimensions, newX);
                    newY = checkYWithRoomSize(roomDimensions, newY);
                    corners[0].moveTo(newX, corners[0].getPosition().y, 0);
                    corners[1].moveTo(newX, newY, 0);
                    corners[2].moveTo(roomDimensions.minX / 2, newY, 0);
                    corners[3].moveTo(roomDimensions.minX / 2, newY, corners[3].getPosition().z);
                }
                break;
            case corners[3]: {
                newX = Math.max(corners[1].getPosition().x + closestToSibblingHandle, corners[0].getPosition().x + minWidth, newX);
                const minY = corners[2].getPosition().y < minHeight ? minHeight : closestToSibblingHandle;
                newY = Math.max(newY, minY);
                newX = checkXWithRoomSize(roomDimensions, newX);
                newY = checkYWithRoomSize(roomDimensions, newY);
                corners[3].moveTo(corners[3].getPosition().x, newY, newZ);
                corners[1].moveTo(corners[1].getPosition().x, newY, 0);
                corners[2].moveTo(roomDimensions.minX / 2, newY, 0);
                corners[4].moveTo(roomDimensions.maxX / 2, 0, newZ);
                break;
            }
            case corners[4]: {
                /*
                 * Horizontal:
                 * Should also move handle 3
                 * Cannot move closer past handle 2
                 * Cannot move closer to handles 0/1 than minWidth
                 */
                newX = Math.max(corners[3].getPosition().x + closestToSibblingHandle, corners[5].getPosition().x + minWidth, newX);
                newX = checkXWithRoomSize(roomDimensions, newX);
                corners[3].moveTo(roomDimensions.minX / 2, corners[3].getPosition().y, newZ);
                corners[4].moveTo(roomDimensions.maxX / 2, 0, newZ);
                // We need to update corner 5 mostly for when room size changes
                corners[5].moveTo(roomDimensions.maxX / 2, 0, 0);
                break;
            }
            default:
                break;
        }
    }
}
//# sourceMappingURL=SquaredShapeRightCorner.js.map